import useFormApi from "@data-driven-forms/react-form-renderer/use-form-api";
import React, { useEffect, useState } from "react";
import { Grid } from "@mui/system";
import { Button } from "@mui/material";
import { ElementType } from "react";

interface StaffFormTemplateProps {
  formFields: ElementType[],
  onSubmit: (data: any) => void;
}

export const StaffFormTemplate = ({ formFields, onSubmit }: StaffFormTemplateProps) => {
  const { getState } = useFormApi();
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (!isSubmitting) return;
    const { values } = getState();
    // Remove the productName check as it's not relevant for staff
    const { values: updatedValues } = getState();
    onSubmit(updatedValues);
  }, [isSubmitting]);

  return (
    <form
      style={{
        width: 'auto'
      }}
      onSubmit={(event) => {
        event.preventDefault();
        setIsSubmitting(true);
      }}
    >
      <Grid container justifyContent="space-between" spacing={1}>
        {formFields}
      </Grid>

      <Button sx={{
        marginTop: '20px'
      }} variant={'contained'} onClick={e => setIsSubmitting(!isSubmitting)}>Submit</Button>

    </form>
  );
};
